import api from "./axios";

export async function listConnectors() {
  const response = await api.get("/connectors");
  return response.data;
}

export async function getConnector(connectorId) {
  const response = await api.get(`/connectors/${connectorId}`);
  return response.data;
}

export async function createConnector(payload) {
  const response = await api.post("/connectors", payload);
  return response.data;
}
